var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrokenClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    fill: "lightskyblue",
    transform: "scale(0.8,-0.8)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100,-0.100)",
    fill: "lightskyblue",
    stroke: "lightskyblue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219 400 c-13 -10 -20 -19 -15 -20 18 0 76 24 76 32 0 15 -38 8 -61 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 412 c0 -10 45 -32 63 -32 17 1 -32 40 -49 40 -8 0 -14 -4 -14 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 356 c0 -8 59 -34 64 -28 17 17 3 32 -29 32 -19 0 -35 -2 -35 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398 354 c-4 -5 -3 -25 1 -44 6 -27 10 -31 16 -18 8 19 -8 77 -17 62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 310 c-13 -24 -13 -30 -2 -30 11 0 37 39 37 55 0 16 -22 0 -35 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 275 c0 -5 50 -55 55 -55 12 0 3 29 -13 43 -17 16 -42 23 -42 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 251 c-13 -23 -15 -61 -3 -61 11 0 31 70 21 76 -4 2 -13 -4 -18 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 165 c-27 -36 -21 -54 7 -22 25 28 32 47 18 47 -5 0 -16 -11 -25 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 151 c0 -6 13 -17 30 -26 33 -17 40 -18 40 -7 0 8 -14 16 -62 40 -5 2 -8 -1 -8 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 120 c0 -5 18 -10 40 -10 22 0 40 5 40 10 0 6 -18 10 -40 10 -22 0 -40 -4 -40 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 120 c0 -5 18 -10 40 -10 22 0 40 5 40 10 0 6 -18 10 -40 10 -22 0 -40 -4 -40 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 120 c0 -5 18 -10 40 -10 22 0 40 5 40 10 0 6 -18 10 -40 10 -22 0 -40 -4 -40 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenClouds);
export default __webpack_public_path__ + "static/media/broken-clouds.8d5b8f9ae490e45172c164c01534be3e.svg";
export { ForwardRef as ReactComponent };